import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

// Кнопка-действие пульта со спиннером на время запроса. В отличие от ToggleButton
// у действия нет ws-флага для подтверждения, поэтому pending держится до ответа POST —
// организатор видит, что команда обрабатывается, если бэк отвечает не мгновенно.
export default function ActionButton({ label, onClick, className }) {
    const [pending, setPending] = useState(false);
    const mountedRef = useRef(true);

    useEffect(() => () => { mountedRef.current = false; }, []);

    const handleClick = () => {
        if (pending) return;
        setPending(true);
        Promise.resolve(onClick()).finally(() => {
            if (mountedRef.current) setPending(false);
        });
    };

    return (
        <button type="button" className={`${className}${pending ? ' pending' : ''}`} disabled={pending} onClick={handleClick}>
            {pending && <span className="cbtn-spin" aria-hidden="true" />}
            {label}
        </button>
    );
}

ActionButton.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string
};

ActionButton.defaultProps = {
    className: 'cbtn cbtn-amber'
};
